// extracted by mini-css-extract-plugin
export var animateDot = "FloatingThingy-module--animateDot--c0dad";
export var animatePanel = "FloatingThingy-module--animatePanel--98dfa";
export var button = "FloatingThingy-module--button--5446a";
export var close = "FloatingThingy-module--close--7e060";
export var closed = "FloatingThingy-module--closed--b852f";
export var dot = "FloatingThingy-module--dot--5ce45";
export var floatingThingy = "FloatingThingy-module--floatingThingy--cc04b";
export var open = "FloatingThingy-module--open--fc088";
export var panel = "FloatingThingy-module--panel--4eb78";
export var panelVariant = "FloatingThingy-module--panelVariant--ff1d9";